// extracted by mini-css-extract-plugin
export default {"lists":"Lists_lists__tIcC8","heading":"Lists_heading__ePcxC","listLink":"Lists_listLink__HqJ1E"};